import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";

var ContentImageSlideshowRight = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ContentImageSlideshowRight.prototype.init = function() {

	var self = this;

	// sliders
	this.$imageSlider = this.options.$el.find('.image-slider')

	// initialize image slider
	this.$imageSlider.slick({
		arrows: false,
		fade: true,
		speed: 750,
		autoplay: true,
		autoplaySpeed: 5000,
	});

	this.$imageSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	
		self.updateSlideCounter(nextSlide + 1);

	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideCounterEq = new Equalizer( self.options.$el.find('.slide-counter, .slide-counter .slide-number') );

	this.slideCounterEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideCounterEq.equalizeHeights();
	});

};

ContentImageSlideshowRight.prototype.updateSlideCounter = function(slideNumber){

	var self = this;

	this.options.$el.find('.slide-number').removeClass('active');

	this.options.$el.find('.slide-number[data-slide-number="' + slideNumber + '"]').addClass('active');

};

export default ContentImageSlideshowRight;
